import { KYBStatusEnum } from "@finway-group/shared/lib/models"
import store from "Shared/store"
import { fetchCardOverviewData } from "Shared/store/actions/analytics/analyticsActions"
import { fetchWallet } from "Shared/store/actions/corporate/corporateActions"
import UserService from "../user.service"

const subscribeToWallet = (dispatch: any) => {
    const loggedInUser = UserService.getLoggedInEmployeeProfile()
    const cardsActivated = store.getState().corporate.kybData.kybStatus === KYBStatusEnum.COMPLETED
    if (loggedInUser.activeCompanyProfile.isAdmin && cardsActivated) {
        dispatch(fetchWallet())
        dispatch(fetchCardOverviewData())
    }
}

export default subscribeToWallet
